<template>
  <div class="resource_tree">
    <el-tree
      ref="resTree"
      :default-checked-keys="[parentId]"
      :data="treeData"
      @node-click="nodeClick"
      :props="defaultProps"
      node-key="id"
      :accordion="accordion"
      :highlight-current="true"
      :default-expanded-keys="expandedKeys"
    >
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'ZkResourceTree',
  data() {
    let defaultProps = {
      children: 'children',
      label: (data, node) => {
        // let i18nKey = data['i18nKey']
        // if (i18nKey) {
        //   let value = this.$t(i18nKey)
        //   if (value !== i18nKey) {
        //     return value
        //   }
        // }
        return data.name
      }
    }
    return {
      defaultProps,
      expandedKeys:
        this.parentId === null || this.parentId === '' ? [] : [this.parentId]
    }
  },
  props: {
    parentId: {
      //
      type: String,
      default: ''
    },
    treeData: {
      type: Array,
      default: function(params) {
        return []
      }
    },
    accordion: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    nodeClick(val) {
      let selectId = this.$refs.resTree.getCurrentKey()
      this.expandedKeys = [selectId]
      this.$emit('nodeClick', selectId)
    },
    getCurrentKey() {
      return this.$refs.resTree.getCurrentKey()
    },
    getNodeById(nodeId) {
      return this.$refs.resTree.getNode(nodeId).data
    },
    getCheckedKeys(node) {
      const checkedKeys = []
      if (!node) {
        return
      }
      this.traverse(node, checkedKeys)
      return checkedKeys
    },
    traverse(node, checkedKeys) {
      checkedKeys.push(node.id)
      if (node.children && node.children.length > 0) {
        let i = 0
        for (i = 0; i < node.children.length; i++) {
          this.traverse(node.children[i], checkedKeys)
        }
      }
    }
  },
  mounted() {
    this.$refs.resTree.setCurrentKey(this.parentId)
    console.log('5555')
  },
  watch: {
    parentId(val) {
      if (val !== null && val !== '') {
        this.expandedKeys = [val]
      } else {
        this.expandedKeys = []
      }
      this.$refs.resTree.setCurrentKey(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/resourceTree/src/main.vue